export function getHorizontalVisibilityPercentage(el, container) {
  const elementRect = el.getBoundingClientRect()
  const containerRect = container.getBoundingClientRect()
  const visibleWidth = Math.min(elementRect.right, containerRect.right) - Math.max(elementRect.left, containerRect.left)
  return visibleWidth >= 0 ? (visibleWidth / elementRect.width) * 100 : 0
}
